import React, { useContext } from "react";
import { jwtDecode } from "jwt-decode";
import {
    CustomMenuItem,
    LinkTab,
    ProfileMenuWrapper,
    StyledMenu,
} from "./Styled";
import IconButton from "../../../shared/components/IconButton";
import ArrowDownIcon from "../../../shared/svg/ArrowDownIcon";
import { authService } from "../../../services/authService";
import { AuthenticationContext } from "../../../provider/AuthenticationProvider";
import { useNavigate } from "react-router-dom";
import { getStoredAuthToken } from "../../../utils/authToken";
import { ROLE } from "../../../data/enums";

const ProfileMenu = () => {
    const navigate = useNavigate();
    const { setLoggedIn, user } = useContext(AuthenticationContext);
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleLogout = () => {
        authService.logout();
        setLoggedIn(false);
    };

    const onClickUserDetail = () => {
        const token = getStoredAuthToken();
        if (token) {
            try {
                const decodedToken: any = jwtDecode(token);
                const userId = decodedToken.user_id;
                navigate(`/users/${userId}#info-tab`);
                handleClose();
            } catch (error) {}
        }
    };

    const onClickImport = () => {
        navigate("/utils/import");
        handleClose();
    };

    return (
        <ProfileMenuWrapper>
            <IconButton onClick={handleClick}>
                <ArrowDownIcon />
            </IconButton>

            <StyledMenu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                    "aria-labelledby": "basic-button",
                }}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "right",
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                }}
                PaperProps={{
                    style: {
                        overflowY: "auto",
                        marginTop: "16px",
                    },
                }}
            >
                <CustomMenuItem>
                    <LinkTab onClick={onClickUserDetail}>
                        Thông tin tài khoản
                    </LinkTab>
                </CustomMenuItem>
                {user?.role === ROLE.MANAGER && (
                    <CustomMenuItem>
                        <LinkTab onClick={onClickImport}>
                            Nhập dữ liệu hàng loạt
                        </LinkTab>
                    </CustomMenuItem>
                )}
                <CustomMenuItem onClick={handleLogout}>
                    Đăng xuất
                </CustomMenuItem>
            </StyledMenu>
        </ProfileMenuWrapper>
    );
};

export default ProfileMenu;
